var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigmainoutgoingcall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-228 -540)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(228 540)",
    fill: "#04b54b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(171.903 136.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calllogs",
    transform: "translate(70.969 419.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M18.018,14.966l-1.25-1.207a1.639,1.639,0,0,0-2.261,0l-.983.949a.777.777,0,0,1-.836.163A13.485,13.485,0,0,1,8.6,12.144,13.013,13.013,0,0,1,5.786,8.215a.736.736,0,0,1,.173-.835l.88-.85A1.537,1.537,0,0,0,6.93,4.259L5.679,3.052a2.186,2.186,0,0,0-3.015,0l-.7.67a3.213,3.213,0,0,0-.906,2.954,16.032,16.032,0,0,0,4.755,8.155,16.923,16.923,0,0,0,8.446,4.592,3.485,3.485,0,0,0,3.059-.875l.694-.67A2.01,2.01,0,0,0,18.018,14.966Z",
    transform: "translate(-1 -2.449)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "up-arrow-svgrepo-com",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 85.311, 419.117)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "primary",
    y1: 6.491,
    x2: 0.121,
    transform: "translate(2.228 0.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M4.587,3,2.294,0,0,3",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigmainoutgoingcall);
export default __webpack_public_path__ + "static/media/bigmainoutgoingcall.1ff750a5e4b8cc03c38b8202edbff253.svg";
export { ForwardRef as ReactComponent };